<!-- FILE: request-reminder.component.html · _40 #223 · wiederkehrende Erinnerung -->
@if (req.due(); as q) {
  @if (!req.panelOpen()) {
    <article class="remind" data-testid="remind.card" role="alert" aria-live="assertive">
      <header class="remind__head">
        <span class="remind__badge">Waiting for your answer</span>
        <button type="button" class="remind__x" data-testid="remind.x" (click)="dismiss(q.message_id)" aria-label="Remind me later">×</button>
      </header>
      <p class="remind__meta">
        <b>{{ q.from.display_name }}</b>@if (q.from.is_agent) { <span class="remind__tag">AI</span> }
        · {{ q.anchor.type === 'pslot' ? 'project' : q.anchor.type + ' #' + q.anchor.id }}
        · {{ q.pslot }} · {{ ageOf(q.created_at) }}
      </p>
      <p class="remind__appeal">{{ q.cflx.appeal }}</p>
      <footer class="remind__actions">
        <button type="button" class="remind__btn remind__btn--main" data-testid="remind.reply" (click)="reply(q.message_id)">Reply</button>
        <button type="button" class="remind__btn" data-testid="remind.done" (click)="done(q.message_id)">Done</button>
        <button type="button" class="remind__btn" data-testid="remind.obsolete" (click)="obsolete(q.message_id)">Obsolete</button>
        <button type="button" class="remind__btn remind__btn--quiet" data-testid="remind.later" (click)="later(q.message_id)">Later (1 h)</button>
      </footer>
    </article>
  }
}
